import { render, staticRenderFns } from "./BindCard.vue?vue&type=template&id=be32290a&scoped=true"
import script from "./BindCard.vue?vue&type=script&lang=js"
export * from "./BindCard.vue?vue&type=script&lang=js"
import style0 from "./BindCard.vue?vue&type=style&index=0&id=be32290a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be32290a",
  null
  
)

export default component.exports